import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

const FAMILY_ONE =
  "https://images.unsplash.com/photo-1592599457566-c660153d9548?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";
const FAMILY_TWO =
  "https://images.unsplash.com/photo-1685580388390-576100ae9ce3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export const About = () => (
  <section
    id="heritage"
    data-testid="about-section"
    className="relative py-24 md:py-32"
    style={{ background: "linear-gradient(180deg, #050e1d 0%, #081226 100%)" }}
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <Reveal>
        <div className="relative pb-16 pr-16">
          <div className="relative overflow-hidden rounded-2xl border border-[#bf953f]/25">
            <motion.img
              initial={{ scale: 1.15 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
              src={FAMILY_ONE}
              alt="A family protected by Heritage"
              className="h-[380px] md:h-[460px] w-full object-cover"
              data-testid="about-image-one"
            />
            <div className="absolute inset-0 shadow-[inset_0_0_120px_60px_rgba(5,5,5,0.55)]" />
          </div>
          <div className="absolute bottom-0 right-0 w-2/3 overflow-hidden rounded-2xl border-2 border-[#081226] ring-1 ring-[#bf953f]/30 shadow-[0_20px_50px_rgba(0,0,0,0.6)]">
            <motion.img
              initial={{ scale: 1.15 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
              src={FAMILY_TWO}
              alt="Another family protected by Heritage"
              className="h-[200px] md:h-[250px] w-full object-cover"
              data-testid="about-image-two"
            />
            <div className="absolute inset-0 shadow-[inset_0_0_80px_40px_rgba(5,5,5,0.45)]" />
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <p className="font-body text-xs md:text-sm tracking-[0.3em] uppercase text-[#d4af37]">Our Heritage</p>
          <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight text-white">
            Built to guard <span className="text-gold-gradient italic">generations.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 font-body font-light text-base md:text-lg leading-relaxed text-white/65">
            Heritage Family Protection Agency was founded on a single conviction: that every family deserves
            a shield strong enough to outlast them. From kitchen tables to boardrooms, we translate complex
            insurance, legal, and retirement decisions into plans that simply work.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-5 font-body font-light text-base md:text-lg leading-relaxed text-white/50">
            Our agents are independent by design — beholden only to you, never to a single carrier — so the
            coverage they recommend is always the coverage that's right.{" "}
            <Link to="/meet-the-team" data-testid="about-browse-agents-link" className="text-[#d4af37] hover:text-[#fcf6ba] underline underline-offset-4 transition-colors">
              Browse our agents
            </Link>{" "}
            to find the one who can offer you the best coverage.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-8 hairline w-40" />
          <p className="mt-6 font-serif-display italic text-2xl text-gold-gradient">
            Protecting Families · Preserving Legacies.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
